import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutomotiveAftermarketProfileEndpoint } from '../constants/automotive-aftermarket-profile-endpoint';
import { AutomotiveAftermarketProfileListStateModel } from './automotive-aftermarket-profile-list.state';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { PlannerProfileListSearchCriteria } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketProfileListService {
  constructor(private http: WrapperHttpService) {}

  getAutomotiveAftermarketProfileList(
    searchCriteria: PlannerProfileListSearchCriteria,
  ): Observable<AutomotiveAftermarketProfileListStateModel> {
    const url =
      `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<AutomotiveAftermarketProfileListStateModel>(url);
  }
}
